module.exports = __webpack_public_path__ + "static/media/final-l.f205d5ad.png";